import React from 'react'
import {useRouter} from 'next/router'
import {useTranslation} from 'next-i18next'
import Button from '@components/Button'
import styles from './styles.module.css'

export default function ActionButtons(props) {
  const {setOpenResume} = props
  const router = useRouter()
  const {t} = useTranslation('website', {keyPrefix: 'order.cart'})

  async function checkPlease() {
    router.push('/checkout-on-table/checkout')
  }

  return (
    <div className={styles.container}>
      <Button fullWidth primary onClick={checkPlease}>
        {t('payAndCloseTable')}
      </Button>
      <div className={styles.button}>
        <Button onClick={() => setOpenResume(false)} fullWidth>
          {t('continueOrderingToTable')}
        </Button>
      </div>
    </div>
  )
}
